module.exports = __webpack_public_path__ + "static/img/Examples1.2d0e6e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/followup/Examples1.png
// module id = nAVA
// module chunks = 1